import React, { useContext, useMemo } from 'react'
import { FormattedMessage, useIntl, FormattedNumber } from 'react-intl'
import messages from './messages'
import { ProjectContext } from 'contexts/ProjectContext'

const CATEGORY_PRICES = {
  advertising: [{ EUR: 395, GBP: 380, DKK: 3250, USD: 455 }, null],
  commercial: [{ EUR: 395, GBP: 380, DKK: 3250, USD: 455 }, null],

  elearning: [{ EUR: 295, GBP: 280, DKK: 2250, USD: 345 }, 600],
  ivr: [{ EUR: 210, GBP: 190, DKK: 1650, USD: 250 }, 300],
  gaming: [{ EUR: 295, GBP: 280, DKK: 2250, USD: 345 }, 300],
  'video-presentation': [{ EUR: 285, GBP: 275, DKK: 2250, USD: 345 }, 600],
  technology: [{ EUR: 295, GBP: 280, DKK: 2250, USD: 345 }, 600],
}

const PriceWrapper = ({
  className = 'font-medium text-sm text-gray-600 cursor-default inlne-block align-top leading-none',
  ...props
}) => <span className={className} {...props} />

const Price = ({ autoHide = false, showPerVoiceTalentLabel = false, onRequest, ...props }) => {
  const {
    project: { medium, category },
  } = useContext(ProjectContext)

  const { locale } = useIntl()

  const [words, currency, value] = useMemo(() => {
    if (!category) {
      return [null, null, null]
    }

    if (!(category in CATEGORY_PRICES)) {
      return [null, null, null]
    }

    let [values, wordCount] =
      medium && category === 'advertising'
        ? {
            'national-tv': [{ EUR: 735, GBP: 695, DKK: 6500, USD: 845 }, null],
            'national-radio': [
              { EUR: 455, GBP: 440, DKK: 3750, USD: 525 },
              null,
            ],
            'paid-online': [{ EUR: 395, GBP: 380, DKK: 3250, USD: 455 }, null],
            'national-cinema': [
              { EUR: 340, GBP: 325, DKK: 2790, USD: 395 },
              600,
            ],
          }[medium]
        : CATEGORY_PRICES[category]

    const currency = {
      en: 'EUR',
      'en-us': 'USD',
      'en-za': 'ZAR',
      'en-gb': 'GBP',
      'da-dk': 'DKK',
      'sv-se': 'SEK',
      'de-de': 'EUR',
    }[locale]

    const value = values[currency] ?? 0.0

    return [wordCount, currency, value]
  }, [medium, category])

  if (onRequest) {
    return (
      <PriceWrapper {...props}>
        <FormattedMessage {...messages.onRequest} />
      </PriceWrapper>
    )
  }

  if (!value && autoHide) {
    return null
  }

  if (!value) {
    return (
      <PriceWrapper {...props}>
        <FormattedMessage {...messages.actionRequired} />
      </PriceWrapper>
    )
  }

  const price = (
    <FormattedNumber
      value={value}
      style="currency"
      currency={currency}
      minimumFractionDigits={0}
      maximumFractionDigits={0}
    />
  )

  return (
    <PriceWrapper {...props}>
      {words ? (
        <FormattedMessage
          {...messages.maxWordsPrice}
          values={{ price, words }}
        />
      ) : (
        <FormattedMessage {...messages.absolutePrice} values={{ price }} />
      )}

      { showPerVoiceTalentLabel &&
        <div className="text-sm text-gray-600"><FormattedMessage {...messages.perVoiceTalent} /></div>
      }
    </PriceWrapper>
  )
}

export default Price
